<template>
  <b-modal :id="id">
    <b-table
      responsive
      :fields="columns"
      :items="tableData"
    />
  </b-modal>
</template>

<script>
import { BModal, BTable } from 'bootstrap-vue'

export default {
  components: { BModal, BTable },
  props: {
    id: {
      type: String,
      required: true,
    },
    zoneDistribution: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const columns = ['zone', 'count']
    const tableData = props.zoneDistribution.map(el => ({
      count: el.doc_count,
      zone: el.key.split('::')[1],
    }))
    return {
      columns,
      tableData,
    }
  },
}
</script>

<style>

</style>
